import { render, staticRenderFns } from "./404-basic.vue?vue&type=template&id=438db226&scoped=true"
import script from "./404-basic.vue?vue&type=script&lang=js"
export * from "./404-basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438db226",
  null
  
)

export default component.exports